import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ca-call-to-action',
    templateUrl: './call-to-action.component.html',
    styleUrls: ['./call-to-action.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallToActionComponent {
    @Input() innerText: string;
    @Input() routeLink: string;
    @Input() openInNewPage: boolean = false;
    @Input() className?: string;
}
